/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconClockHour6Filled = createReactComponent("filled", "clock-hour-6-filled", "IconClockHour6Filled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-6 12.16a1 1 0 0 0 2 0v-8.5a1 1 0 0 0 -2 0z", "key": "svg-0" }]]);

export { IconClockHour6Filled as default };
//# sourceMappingURL=IconClockHour6Filled.mjs.map
